import { Event } from 'three';
import { $ } from '@/Engine/stateInstance';
import { useStoreData } from '@/Store/storeData';
import { useConfigurationStore } from '@/Store/storeConfiguration';
import { afterMoveHandler } from '@/Engine/eventHandlers/afterMoveHandler';

export const onDropHandler = (e: Event) => {
    e.preventDefault();
    $.dndMode = false;

    afterMoveHandler();

};
